import type { ContentfulCloudinaryAssetField, ModalProps } from "@project/ui";
import {
    CldImage,
    hasCloudinaryAsset,
    Box,
    Modal,
    ModalBody,
    ModalContent,
    ModalOverlay,
    ModalCloseButton,
    mediaQueryMinWidth,
} from "@project/ui";
import { WrapperContainer } from "@/components/wrapper-container";

type ModalImageProps = Omit<ModalProps, "children"> & {
    cloudinaryAsset?: ContentfulCloudinaryAssetField;
    alt: string;
};

const ModalImage = (props: ModalImageProps) => {
    const { isOpen, onClose, cloudinaryAsset, alt } = props;

    const handleOnClose = () => {
        onClose();
    };

    return (
        <Modal
            isOpen={isOpen}
            onClose={handleOnClose}
            isCentered
            autoFocus={false}
            returnFocusOnClose={false}
            motionPreset="slideInBottom"
            size="cldAsset"
        >
            <ModalOverlay />
            <ModalContent bg="transparent" borderRadius={{ base: 0, md: "large" }} p={0} m={0}>
                <ModalBody
                    px={{
                        base: 4,
                        l: 10,
                    }}
                >
                    <WrapperContainer position="relative" px={0}>
                        {hasCloudinaryAsset(cloudinaryAsset) && (
                            <Box
                                height={{
                                    base: "100svh",
                                    l: "90vh",
                                }}
                                rounded={{ md: "large" }}
                            >
                                <CldImage
                                    cloudinaryAsset={cloudinaryAsset}
                                    sizes="100vw"
                                    crop="fill"
                                    objectFit="contain"
                                    alt={alt}
                                />
                            </Box>
                        )}
                        {/* setting right to 40px (wrapper container padding) + 24px (design) */}
                        <ModalCloseButton
                            variant="primary"
                            sx={{
                                [mediaQueryMinWidth.md]: {
                                    right: "--space-6",
                                },
                            }}
                        />
                    </WrapperContainer>
                </ModalBody>
            </ModalContent>
        </Modal>
    );
};

export { ModalImage };
